import React, { useState, useEffect } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { projectFirestore } from '../firebase/config';

const Newsdata = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = projectFirestore.collection('news')
      .orderBy('order', 'asc')
      .onSnapshot((snap) => {
        setNewsItems(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoading(false);
      });
    return () => unsub();
  }, []);

  if (loading) return <div className="text-center py-4"><div className="spinner-border text-light"></div></div>;

  if (newsItems.length === 0) {
    return (
      <div className="text-center py-4">
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.1rem' }}>لا توجد أخبار حالياً</p>
      </div>
    );
  }

  return (
    <Row xs={1} md={2} className="g-4">
      {newsItems.map(item => (
        <Col key={item.id}>
          <Card className="news-card h-100">
            {item.imageUrl && (
              <Card.Img variant="top" src={item.imageUrl}
                style={{ maxHeight: 280, objectFit: 'cover' }} />
            )}
            {(item.title || item.content) && (
              <Card.Body>
                {item.title && <Card.Title className="fw-bold">{item.title}</Card.Title>}
                {item.content && <Card.Text style={{ whiteSpace: 'pre-wrap' }}>{item.content}</Card.Text>}
                {item.createdAt && (
                  <small className="text-muted">{new Date(item.createdAt).toLocaleDateString('ar-EG')}</small>
                )}
              </Card.Body>
            )}
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default Newsdata;
